import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageGridRow = function LandingPageGridRow(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "mx-auto px-4 md:px-0 max-w-full md:max-w-3/5",
    children: [/*#__PURE__*/_jsx("div", {
      className: "font-serif text-3xl md:max-w-3/5 mx-auto mb-6 md:text-center leading-10",
      children: props.title
    }), /*#__PURE__*/_jsx("div", {
      className: "font-dmsans text-xl md:max-w-half mx-auto md:text-center mb-18 leading-7",
      children: props.subtitle
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-column md:grid md:grid-cols-".concat(props.items.length, " gap-6"),
      children: props.items.map(function (item) {
        return /*#__PURE__*/_jsxs("div", {
          className: "flex flex-column",
          children: [/*#__PURE__*/_jsx("div", {
            className: "h-16",
            children: /*#__PURE__*/_jsx("img", {
              className: "",
              src: item.imageHref
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4 font-dmsans text-lg md:text-2xl leading-snug md:leading-snug fw-700 text-gray-900",
            children: item.title
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-1 font-dmsans leading-snug md:leading-snug text-gray-900",
            children: item.body
          })]
        }, item.title);
      })
    })]
  });
};

export default LandingPageGridRow;